import { BASE_ADMIN_API_ROOT_PATH } from '../../shared/api/constants/path.constants';

export const ADMIN_TAXES_API_ROOT = `${BASE_ADMIN_API_ROOT_PATH}/taxes`;

export const ADMIN_TAXES_API_PATHS = {
  GET_TAXES: `${ADMIN_TAXES_API_ROOT}`,
  CREATE_TAX: `${ADMIN_TAXES_API_ROOT}`,
  UPDATE_TAX: (taxId: string) => `${ADMIN_TAXES_API_ROOT}/${taxId}`,
  DELETE_TAX: (taxId: string) => `${ADMIN_TAXES_API_ROOT}/${taxId}`,
};
